import * as tslib_1 from "tslib";
import { AfterViewInit, EventEmitter, Injector, OnChanges, OnDestroy, OnInit, SimpleChanges, Type } from "@angular/core";
import { DxGridOptions } from "../../domain/ui-options/dx-grid-options";
import { forkJoin, Subject } from "rxjs";
import { DxGridState } from "../../domain/dx-grid-state";
import { DxAppError } from "../../../dx-core/domain/error/dx-app-error";
import { DxGridToolbarActionType } from "../../domain/ui-options/toolbar/dx-grid-toolbar-action-type";
import { DxAppEvent } from "../../../dx-core/domain/events/dx-app-event";
import { AgGridAngular } from "ag-grid-angular";
import { AgGridDatasource } from "../../services/ag-grid-datasource";
import { DxGridUtils } from "../../domain/dx-grid-utils";
import { AgGridUtils } from "../../domain/ag-grid/ag-grid-utils";
import { DxGridDataType } from "../../domain/dx-grid-data-type";
import { DxNumericCellEditorComponent } from "./editors/nuneric/dx-numeric-cell-editor.component";
import { DxLinkCellRenderComponent } from "./renders/link/dx-link-cell-render.component";
import { DxCurrencyCellRenderComponent } from "./renders/currency/dx-currency-cell-render.component";
import { DxNciService } from "../../../dx-nci-core/services/dx-nci.service";
import { DxDictionaryCellRenderComponent } from "./renders/dictionary/dx-dictionary-cell-render.component";
import { DxCheckboxCellRenderComponent } from "./renders/checkbox/dx-checkbox-cell-render.component";
import { DxCheckboxCellEditorComponent } from "./editors/checkbox/dx-checkbox-cell-editor.component";
import { DxDatetimeCellRenderComponent } from "./renders/datetime/dx-datetime-cell-render.component";
import { map } from "rxjs/operators";
import { DxDictionaryFloatingFilterComponent } from "./renders/dictionary-filter/dx-dictionary-floating-filter.component";
import { debounce } from "../../../dx-core/utiles/debounce";
export class DxGridComponent {
    constructor(_injector, _nciService) {
        this._injector = _injector;
        this._nciService = _nciService;
        /** Флаг индикации загрузки списка */
        this._isLoading = true;
        /**
         * Логика управления доступностью можеть быть сложной, поэтому доступ
         * к этому полю через геттер.
         */
        this._isDisabled = false;
        this.rowClassRules = {};
        /* ============================================================================================================= */
        /*                                          События комопонента                                                  */
        /* ============================================================================================================= */
        /**
         * У панели инструментов грида есть два режима работы:
         *
         * 1. Внутренняя обработка действий с панели инструментов через втроенные методы.
         *
         * 2. Режим внешнего обработчика действий панели инструментов. Это добавляет гибкости при встраивании в дизайн
         *    + не надо тащить всякое говно и костыли в код компонента, просто реализовав обработку
         *    снаружи списка в прикланом компоненте.
         *
         * Короче можно использовать механизмы создания и управления тулбаром, предоставляемые гридом,
         * но обрабатывать действия с панели инструментов вне грида.
         */
        this.toolbarAction = new EventEmitter();
        /** Событие выбрасывается при сбросе фильтров грида по кнопке "Сбросить фильтры" на панели инструментов. */
        this.filtersFlush = new EventEmitter();
        /** Событие выбрасывается при выделении строки в гриде. */
        this.rowsSelect = new EventEmitter();
        /** Событие выбрасывается при снятии выделения со строки в гриде. */
        this.rowsDeselect = new EventEmitter();
        /** Событие выбрасывается при удалении строки в гриде. */
        this.rowsRemove = new EventEmitter();
        this.rowDataUpdated = new EventEmitter();
        /**
         * Событие выбрасывается по завершению инициализации грида.
         * Но данные еще могут быть не подтянуты при серверной модели данных.
         */
        this.gridReady = new EventEmitter();
        /** Событие выбрасывается при обновлении грида через тулбар. */
        this.gridRefresh = new EventEmitter();
        /**
         * Событие выбрасывается при добавлении, копировании, удалении, редактировании и тд. строк.
         * Это понадобится при использовании грида на формах, чтобы сигнализировать форме о наличии измений.
         */
        this.gridDirty = new EventEmitter();
        /** Событие выбрасывается года грид получил данные. */
        this.dataArrived = new EventEmitter();
        /** событие выбрасывается в результате редактирования значения в ячейке */
        this.cellValueChanged = new EventEmitter();
        this._state = new DxGridState();
        this.stateObservable = new Subject();
        this._toolbarActionHandlers = new Map();
        this._rows = [];
        this._subscriptions = [];
        this._cellEditors = new Map();
        this._cellRenders = new Map();
        this._floatingFilters = new Map();
        this._initCellEditors();
        this._initCellRenders();
        //this._initFloatingFilters();
    }
    get isDisabled() {
        return this._isDisabled;
    }
    /** Свойство доступности */
    set isDisabled(value) {
        this._isDisabled = value;
    }
    /** Данные грида (для работы в режиме клиенской модели данных) */
    set data(value) {
        this._data = value;
    }
    /** Справочники для грида (при работе в режиме клиентской модели данных). */
    set gridDicts(value) {
        this._gridDicts = value;
    }
    onWindowResize(event) {
        this.resize();
    }
    /* ============================================================================================================= */
    /*                                          Хуки жизнненого цилка                                                */
    /* ============================================================================================================= */
    ngOnInit() {
        this._init();
    }
    ngAfterViewInit() { }
    ngOnDestroy() {
        this._destroy();
    }
    ngOnChanges(changes) {
        // Для клиентского режима работы грида организуем возможность обновления данных
        // через инпут.
        if (!this.options.useServerSideDataModel && changes.data) {
            const dataChange = changes.data;
            if (dataChange && dataChange.currentValue) {
                this.fill(dataChange.currentValue);
            }
        }
    }
    /* ============================================================================================================= */
    /*                                          Обработчики событий грида                                            */
    /* ============================================================================================================= */
    /** Обработчик дейсвия на панели нструментов. */
    onToolbarAction(action) {
        // Если для грида определен внешний хэдлер для обработки действий на панели
        // инструментов, то просто транслируем акшен наружу.
        if (this.options.externalToolbarHandler) {
            this.toolbarAction.emit(new DxAppEvent('dx-grid', action));
        }
        else {
            this.handleToolbarAction(action);
        }
    }
    /** Обработчик события `gridReady` комопнента AgGrid. */
    onAgGridReady(params) {
        this._agGridApi = params.api;
        this._agGridColumnApi = params.columnApi;
        if (this.options.useServerSideDataModel) {
            let subscriptions = this._agGridDataSource.loadObservable.subscribe(isLoading => {
                this._handleRowDataLoad(isLoading);
            });
            this._subscriptions.push(subscriptions);
            subscriptions = this._agGridDataSource.loadErrorObservable.subscribe(error => {
                this._handleRowDataLoadError(error);
            });
            this._subscriptions.push(subscriptions);
            subscriptions = this._agGridDataSource.dictsDataObservable.subscribe(data => {
                this._gridDicts = data;
            });
            this._subscriptions.push(subscriptions);
            // Датасорс нужно передавать именно после события gridReady через api
            // Передача через инпут комопнента приводит к двойному запросу данных при инициализации.
            // Фетч в этом случае пойдет автоматически через внутренние механизмы AgGrid
            this._agGridApi.setDatasource(this._agGridDataSource);
        }
        // Если используется клиентская модель данных, то
        // просто заполняем данные для грида
        else {
            this.fill(this._data);
        }
        this.gridReady.emit(new DxAppEvent('dx-grid', this.options.ident));
    }
    onAgGridModelUpdated(event) {
        // при использовании клиент-сайд данных данное событие срабатывает раньше GridReady и _agGridApi может быть undefined
        if (!this._agGridApi)
            this._agGridApi = event.api;
        if (this.options.useServerSideDataModel) {
            if (this.options.allowPagination) {
                this._state.rowsCount = this._agGridApi.paginationGetRowCount();
            }
            else {
                this._state.rowsCount = this._agGridApi.getInfiniteRowCount();
            }
        }
        else {
            if (this.options.allowPagination) {
                this._state.rowsCount = this._agGridApi.paginationGetRowCount();
            }
            else {
                this._state.rowsCount = this._agGridApi.getDisplayedRowCount();
            }
        }
        // this.agGrid.
        // this._agGridDataSource
        // this.fill(this._agGridDataSource.rowCount);
        this.dataArrived.emit(new DxAppEvent('dx-grid'));
        this.notifyStateObservers();
    }
    onRowSelection(event) {
        const selectedRows = this._agGridApi.getSelectedRows();
        if (selectedRows.length > 0) {
            let row;
            selectedRows.forEach(agRow => {
                row = agRow;
                row.isSelected = true;
                this._state.addSelection(row);
            });
            this.rowsSelect.emit(new DxAppEvent('dx-grid', selectedRows));
        }
        else if (this._state.hasSelection) {
            this.rowsDeselect.emit(new DxAppEvent('dx-grid'));
            this._state.clearSelected();
        }
        this.notifyStateObservers();
    }
    onFilterChange(event) {
        this._state.filterModel = this._agGridApi.getFilterModel();
        this.notifyStateObservers();
    }
    onCellValueChanges(event) {
        const row = event.data;
        if (row.isNew) {
            this._state.updateAddedRow(row);
        }
        else {
            this._state.addUpdatedRow(row);
        }
        this.cellValueChanged.emit(new DxAppEvent('dx-grid', row));
    }
    onColumnResized(event) {
        if (event.column && event.column.colDef.autoHeight)
            this._agGridApi.resetRowHeights();
    }
    /* ============================================================================================================= */
    /*                                          Методы доступа                                                       */
    /* ============================================================================================================= */
    get state() {
        return this._state;
    }
    get rows() {
        return this._rows;
    }
    get cellEditors() {
        return this._cellEditors;
    }
    get cellRenders() {
        return this._cellRenders;
    }
    get floatingFilters() {
        return this._floatingFilters;
    }
    get gridDicts() {
        return this._gridDicts;
    }
    /* ============================================================================================================= */
    /*                                          Публичное API грида                                                  */
    /* ============================================================================================================= */
    /** Регистрирует источник данных списка */
    registerDS(dataSource) {
        this._dataSource = dataSource;
    }
    /** Затирает ссылку на инстанс датасорса */
    unregisterDS() {
        this._dataSource = null;
    }
    /** Уведомляет всех наблюдателей за внутренним состоянием списка. */
    notifyStateObservers() {
        this.stateObservable.next(this._state);
        if (this._state.isDirty) {
            this.gridDirty.emit(new DxAppEvent('dx-grid'));
        }
    }
    /**
     * Регистрирует обработчик действия на панели инструментов.
     * @param {string} type - тип действия на панели инструментов, которое обрабатывает обработчик.
     * @param {(action: DxListToolbarAction) => void} handler - функция-обработчик.
     */
    addToolbarActionHandler(type, handler) {
        if (!this._toolbarActionHandlers)
            this._toolbarActionHandlers = new Map;
        this._toolbarActionHandlers.set(type, handler);
    }
    /**
     * Удаляет обработчик действия на панели инструментов.
     * @param {string} type - тип действия на панели инструментов, которое обрабатывает обработчик.
     */
    removeToolbarActionHandler(type) {
        if (this._toolbarActionHandlers.has(type)) {
            this._toolbarActionHandlers.delete(type);
            return true;
        }
        return false;
    }
    /**
     * Диспетчиризирует обработку действия на панели инструментов, вызывая
     * соотвествующий обработчик. Если он был задан.
     * @param {DxListToolbarAction} action - действие на панели инструментов.
     */
    handleToolbarAction(action) {
        if (this.options.externalToolbarHandler) {
            this.toolbarAction.emit(new DxAppEvent('dx-grid', action));
        }
        else if (this._toolbarActionHandlers.has(action.type)) {
            const handler = this._toolbarActionHandlers.get(action.type);
            handler.apply(this, [action]);
        }
    }
    /**
     * Заполняет массив элементов списка (`DxListItem`) на основании массива провайдеров данных для элементов.
     * @param {DxListItemDataProvider[]} data - массив провайдеров данных для элементов.
     */
    fill(data) {
        if (data) {
            this._rows = data;
            this._state.rowsCount = this._rows.length;
            this.notifyStateObservers();
            this.dataArrived.emit(new DxAppEvent('dx-grid'));
        }
    }
    /**
     * Фильтрует грид на основе переданной мапы фильтров.
     * @param {Map<string, DxGridFilter>} filters - мапа фильров.
     */
    filter(filters) {
        // 1. Флушим фильтр в сэйте грида
        this._state.flushFilter();
        this.notifyStateObservers();
        // 2. Формируем новую модель фильтрации
        const filterModel = AgGridUtils.prepareFilterModel(this.options.columns, filters, this._gridDicts);
        // 3. Сеттим новую модель фильтрации. Изменение модели фильтрации вызвает внутри AgGrid генерирование
        //    события на обновление данных. Поэтому отдельно дергать onFilterChanged() из апи грида не нужно.
        this._agGridApi.setFilterModel(filterModel);
    }
    /** Сбрасывает фильтры грида. */
    flushFilters() {
        // 1. Скидываем собственную модель фитрации в AgGrid
        //    Внури AgGrid это приводит к генерировнию собтия на обновление данных,
        //    поэтому отдельно дергать onFilterChanged() из апи грида не нужно.
        this._agGridApi.setFilterModel(null);
        // 2. Скидываем филтры в стэйте грида.
        this._state.flushFilter();
        this.notifyStateObservers();
    }
    /**
     * Обновляет данные списка на основе асинхронного фетча, если для списка был опереден датасорс.
     * Либо сбрасывает состояние списка на исходное.
     */
    refresh() {
        if (this.options.useServerSideDataModel) {
            // Вызывает сброс кэша и перезагрузку для infinite-модели данных
            this._agGridApi.refreshInfiniteCache();
        }
        else {
            // Вызывает рефреш клиент-сайд модели данных с перевычислением групп, фильтров, сортировок.
            this._agGridApi.refreshClientSideRowModel();
        }
        this._agGridApi.deselectAll();
        this.clear();
    }
    /** Вызывает перерисовку списка без рефетча данных. */
    redraw() {
        throw new DxAppError('Метод DxBaseListComponent.redraw() не имеет реализации!');
    }
    /** Вызывает ресайз грида по горизонтали (подгонку ширины колонок). */
    resize() {
        this._agGridApi.sizeColumnsToFit();
    }
    autoSize() {
        this._agGridColumnApi.autoSizeAllColumns();
    }
    /** При использовании клиентской модели данных после изменения исходных данных данным методом можно подпнуть грид,
     * чтобы он обновился */
    afterUpdateClientData() {
        if (this._agGridApi)
            this._agGridApi.setRowData(this._rows);
    }
    /**
     * Выделяет строку в гриде.
     * @param {DxGridRow} row - объект строки.
     */
    selectRow(row) {
        const nodes = this._agGridApi.getSelectedNodes();
        const node = nodes.find(node => {
            return node.data.getRowId() === row.getRowId();
        });
        if (node) {
            this._state.addSelection(row);
            this.notifyStateObservers();
            this._agGridApi.selectNode(node);
        }
    }
    /**
     * Удаляет строку из гриде.
     * @param {DxGridRow} row - объект строки.
     * @param {number} addIndex - индекс позиции для новой строки в гриде (По-умолчанию добавляет как первую строку).
     */
    addRow(row, addIndex = 0) {
        this._state.addedRows.push(row);
        this.notifyStateObservers();
        this._agGridApi.updateRowData({ add: [row], addIndex: addIndex });
    }
    /**
     * Удаляет строку из гриде.
     * @param {DxGridRow} row - объект строки
     */
    removeRow(row) {
        if (this.options.useServerSideDataModel) {
            let msg = 'Грид работает с серверной моделью данных. ';
            msg += 'В этом режиме прямое удаление данных не возможно. Необходимо удалить строку в БД, ';
            msg += 'а потом обновить данные грида!';
            throw new DxAppError(msg);
        }
        else {
            if (this._state.isSelected(row)) {
                this._state.removeSelection(row);
            }
            this._state.removedRows.push(row);
            //this._rows.splice(this._rows.indexOf(row), 1);
            this.notifyStateObservers();
            this._agGridApi.updateRowData({ remove: [row] });
        }
    }
    /** Очищает состояние списка и структуру данных */
    clear() {
        this._state.flush();
        this.notifyStateObservers();
        if (this._data)
            this._data.length = 0;
        if (this._rows)
            this._rows.length = 0;
    }
    /** Показывает ошибку, возникшую при выполнении операции списком. */
    showError(message) {
        const msg = 'При работе списка возникла ошибка: ';
        this.hideLoader();
        if (this._modalsProvider) {
            this._modalsProvider.showError(msg + message);
        }
        else {
            // TODO: Тут можно показать noDataOverlay в котором отобразить ошибку
            //this._errorMessage = new DxListMessage([msg, message]);
        }
    }
    /** Показывает индикацию загрузки. */
    showLoader() {
        if (!this._isLoading) {
            this._isLoading = true;
            this._agGridApi.showLoadingOverlay();
        }
    }
    /** Скрывает индикацию загрузки. */
    hideLoader() {
        this._isLoading = false;
        this._agGridApi.hideOverlay();
    }
    /** Вызывает обновление опций ag-грида в соответствии с изменениями в опциях грида */
    refreshColumnDefs() {
        this.agGridOptions = AgGridUtils.buildAgGridOptions(this.options, this);
        if (this._agGridApi) {
            this._agGridApi.setColumnDefs(this.agGridOptions.columnDefs);
        }
    }
    /* ============================================================================================================= */
    /*                                          Приватная логика грида                                               */
    /* ============================================================================================================= */
    /** Инициализирует компонент. */
    _init() {
        // TODO: Пока так. Наверно, имее смысл дописать фвормирование дефолтных настроек.
        const error = DxGridUtils.verifyOptions(this.options);
        if (error) {
            let msg = 'Функционаирование грида не возможно! ';
            msg += 'Обнаружены критические ошибки конфигурации грида: ' + error.join(', ') + '.';
            throw new DxAppError(msg);
        }
        else {
            this._state.allowMultiSelect = this.options.allowMultiSelect;
            this.agGridOptions = AgGridUtils.buildAgGridOptions(this.options, this);
            this._bind();
            // Если грид работает в режиме серверной модели данных, то получаем инстансы датасорсов.
            if (this.options.useServerSideDataModel) {
                // Создаем внутррений датасорс комопнента AgGrid,
                // используемый для работы серверной модели данных.
                this._agGridDataSource = this._injector.get(AgGridDatasource);
                this._agGridDataSource.dxGridOptions = this.options;
                // Получаем инстанс прикладного датасорса
                const dataSources = this._injector.get(this.options.dataSourceIdent);
                this._dataSource = dataSources[0];
                this._agGridDataSource.dxGridDS = this._dataSource;
                if (this.options.hasDictColumns) {
                    this._dictDataSource = this._injector.get(DxNciService);
                    this._agGridDataSource.dxGridDictsDS = this._dictDataSource;
                    this._agGridDataSource.loadDicts = true;
                }
            }
            else { // загрузка справочников для клиентской модели грида
                if (this.options.hasDictColumns) {
                    this._fetchDicts().subscribe(dictsMap => {
                        this._gridDicts = dictsMap;
                    });
                }
            }
        }
        // Фабрика экземляров строк необходима только если грид используется со своим тулбаром и
        // на нем опеределены операции добавления новой строки и копирования существующей.
        if (this.options.showToolbar) {
            const buttons = this.options.toolbar.buttons.filter(btn => {
                return btn.action.type === DxGridToolbarActionType.ADD
                    || btn.action.type === DxGridToolbarActionType.COPY;
            });
            if (buttons && buttons.length > 0) {
                // Получаем инстанс фабрики для создания \ копирования строк
                const factories = this._injector.get(this.options.rowFactoryIdent);
                this._rowFactory = factories[0];
            }
        }
        if (this.options.modalsProviderIdent) {
            const modalProviders = this._injector.get(this.options.modalsProviderIdent);
            this._modalsProvider = modalProviders[0];
        }
    }
    _initCellRenders() {
        this._cellRenders.set(DxGridDataType.LINK, DxLinkCellRenderComponent);
        this._cellRenders.set(DxGridDataType.CURRENCY, DxCurrencyCellRenderComponent);
        this._cellRenders.set(DxGridDataType.DICTIONARY, DxDictionaryCellRenderComponent);
        this._cellRenders.set(DxGridDataType.CHECKBOX, DxCheckboxCellRenderComponent);
        this._cellRenders.set(DxGridDataType.DATE, DxDatetimeCellRenderComponent);
        this._cellRenders.set(DxGridDataType.DATE_TIME, DxDatetimeCellRenderComponent);
        this._cellRenders.set(DxGridDataType.TIME, DxDatetimeCellRenderComponent);
    }
    _initCellEditors() {
        this._cellEditors.set(DxGridDataType.INT, DxNumericCellEditorComponent);
        this._cellEditors.set(DxGridDataType.DOUBLE, DxNumericCellEditorComponent);
        this._cellEditors.set(DxGridDataType.CURRENCY, DxNumericCellEditorComponent);
        this._cellEditors.set(DxGridDataType.CHECKBOX, DxCheckboxCellEditorComponent);
    }
    _initFloatingFilters() {
        this._floatingFilters.set(DxGridDataType.DICTIONARY, DxDictionaryFloatingFilterComponent);
    }
    /** Биндить различного рода обработчики. */
    _bind() {
        if (this.options.showToolbar || this.options.externalToolbarHandler) {
            this.options.toolbar.buttons.forEach(btn => {
                this._bindToolbarActionHandlers(btn.action);
            });
        }
    }
    /** Очищает ресурсы, задействованные компонентом. */
    _destroy() {
        // ОБЯЗАТЕЛЬНО!!!
        this.unregisterDS();
        this._toolbarActionHandlers.clear();
        this._subscriptions.forEach(item => item.unsubscribe());
        this._cellEditors.clear();
        this._cellRenders.clear();
        this._floatingFilters.clear();
    }
    /**
     * Регистрирует обработчики действий панели инструментов, поддерживаемые комопнентом `DxList`.
     * @param {DxListToolbarAction} action - действие, навешанное на кнопку панели инструментов.
     */
    _bindToolbarActionHandlers(action) {
        switch (action.type) {
            case DxGridToolbarActionType.REFRESH:
                this._toolbarActionHandlers.set(DxGridToolbarActionType.REFRESH, this._handleRefreshAction);
                break;
            case DxGridToolbarActionType.FLUSH_FILTERS:
                this._toolbarActionHandlers.set(DxGridToolbarActionType.FLUSH_FILTERS, this._handleFlushFiltersAction);
                break;
            case DxGridToolbarActionType.SAVE:
                this._toolbarActionHandlers.set(DxGridToolbarActionType.SAVE, this._handleSaveAction);
                break;
            case DxGridToolbarActionType.ADD:
                this._toolbarActionHandlers.set(DxGridToolbarActionType.ADD, this._handleAddAction);
                break;
            case DxGridToolbarActionType.EDIT:
                this._toolbarActionHandlers.set(DxGridToolbarActionType.EDIT, this._handleEditAction);
                break;
            case DxGridToolbarActionType.COPY:
                this._toolbarActionHandlers.set(DxGridToolbarActionType.COPY, this._handleCopyAction);
                break;
            case DxGridToolbarActionType.REMOVE:
                this._toolbarActionHandlers.set(DxGridToolbarActionType.REMOVE, this._handleRemoveAction);
                break;
            case DxGridToolbarActionType.XLSX_EXPORT:
                this._toolbarActionHandlers.set(DxGridToolbarActionType.XLSX_EXPORT, this._handleXlsxExportAction);
                break;
            case DxGridToolbarActionType.PDF_EXPORT:
                this._toolbarActionHandlers.set(DxGridToolbarActionType.PDF_EXPORT, this._handlePdfExportAction);
                break;
            default:
                return;
        }
    }
    /** Обработчик обновления грида. */
    _handleRefreshAction(action) {
        if (this._state.hasAddedRows || this._state.hasUpdatedRows) {
            if (this._modalsProvider) {
                let msg = 'В таблице имеются несохраненные изменения! ';
                msg += ' В результате обновления они будут потеряны. ';
                msg += ' Обновить таблицу?';
                this._modalsProvider.showConfirm(msg).subscribe(result => {
                    if (result) {
                        this.gridRefresh.emit(new DxAppEvent('dx-grid'));
                        this.refresh();
                    }
                });
            }
            else {
                this.gridRefresh.emit(new DxAppEvent('dx-grid'));
                this.refresh();
            }
        }
        else {
            this.gridRefresh.emit(new DxAppEvent('dx-grid'));
            this.refresh();
        }
    }
    /** Обработчик сброса ВСЕХ фитров грида. */
    _handleFlushFiltersAction(action) {
        this.filtersFlush.emit(new DxAppEvent('dx-grid'));
        this.flushFilters();
    }
    /**
     * Обработчик сохраненя изменений в гриде:
     * 1. Добавленные строки (новые и копии)
     * 2. Измененные строки
     * 3. Удаленные строки
     *
     * ПС: По-идее, эту функциональность нужно вынести в сервис, но отдельно сервиса в обертке пока не используется.
     * Добавлять в интерфейс датасорса метод, являщийся суперпозицией методов этого датасорса, как то не кошерно.
     */
    _handleSaveAction(action) {
        const asyncTasks = [];
        // При серверной модели данных эти массивы заполняются при использвании
        // инлайн-редактирования строк.
        if (this._state.hasAddedRows) {
            asyncTasks.push(this._dataSource.saveAll(this._state.addedRows));
        }
        if (this._state.hasUpdatedRows) {
            asyncTasks.push(this._dataSource.updateAll(this._state.updatedRows));
        }
        // Что касается удаления строчек!!!
        // Пока что грид работает так что при серверной модели данных удаление идет сразу через сервер
        // и this._state.removedRows не заполняется. А при клиенской модели данных сохранение должно идти
        // через внешний механизм. Можно будет добавить на уровне настроек расширенное управленеие удалением
        // при серверной модели данных.
        /*
        if(this._state.hasRemovedRows) {
          const ids: number[] = [];
          this._state.removedRows.forEach(row => ids.push(row.getRowId()));
          asyncTasks.push(this._dataSource.deleteAll(ids));
        }*/
        this.showLoader();
        forkJoin(asyncTasks).subscribe(data => {
            console.log(data);
            this.hideLoader();
            this.refresh();
        }, error => {
            this.showError(error);
        });
    }
    /**
     * Обработчик добавления строки в грид.
     * Механизм добавления новой строки в грид определяется моделью редактирования грида:
     * 1. Если используется инлайн-редактирование, то через фабрику создается экземпляр новой строки
     *    и просто добавляется в грид. Дальше он должен быть отредактирован пользователем и сохранен
     *    через общее сохранение изменений или через внешние механизмы.
     *
     * 2. Если для редактирования используются модальки, то через фабрику создается экземпляр новой строки
     *    и открывается для редактирования в модальной форме. Что произойдет после закрытия модалки нажатием
     *    на "Сохранить", определяется типом модели данных грида:
     *
     *    2.1. При клиентсякой модели данных строка будет добавлена в грид, а также в стейт.
     *    2.2. При серверной модели данных произойдет предварительное сохранение строки через датасорс.
     */
    _handleAddAction(action) {
        const newRow = this._rowFactory.createRow();
        if (this.options.useInlineEdit) {
            // Если используется встроенное редактирование, просто добавляем новую строку в грид
            // пользователь дальше сам ее отредактирует через редактирование ячеек
            // Сохранение пойдет на этапе сохранения измененний в гриде.
            this._state.addedRows.push(newRow);
            this.notifyStateObservers();
            this._agGridApi.updateRowData({ add: [newRow], addIndex: 0 });
        }
        else {
            // Предотсавление модалки гарантировано на уровне валидации конфигов.
            // Если пользователь нажал в модальном окне на отмену - вернется нул.
            this._modalsProvider.showEditForm(newRow).subscribe(row => {
                if (row) {
                    if (this.options.useServerSideDataModel) {
                        this.showLoader();
                        this._dataSource.save(row).subscribe(result => {
                            this._agGridApi.updateRowData({ add: [result], addIndex: 0 });
                            this.hideLoader();
                        }, error => {
                            this.showError(error);
                        });
                    }
                    else {
                        this._state.addedRows.push(newRow);
                        this.notifyStateObservers();
                        this._agGridApi.updateRowData({ add: [newRow], addIndex: 0 });
                    }
                }
            });
        }
    }
    /**
     * Обработчик копирования строки грида.
     * Механизм копирования определяется типом модели данных грида:
     * 1. При клиентской модели данных через фабрику создается копия и добавляется в таблицу.
     *    Также копия помещается в массив добавленных строк.
     *
     * 2. При серверной модели данных через фабрику создается копия и, перед добавлением в грид,
     *    сохраняется через датасорс. Поэтому в стейт копия не добавляется.
     */
    _handleCopyAction(action) {
        // Единственность выделения гарантируется панелью инструментов
        const selection = this._state.selectedRows[0];
        const copy = this._rowFactory.copyRow(selection);
        // Нужно вычислить индекс для копии в гриде.
        let addIndex = 0;
        const nodes = this._agGridApi.getSelectedNodes();
        const selectedNode = nodes.find(node => {
            return node.data.getRowId() === selection.getRowId();
        });
        addIndex = selectedNode.rowIndex + 1;
        if (this.options.useServerSideDataModel) {
            // Если используется серверная модель данных, то сначала сохраняем копию на сервере,
            // а потом добавляем результат сохранения в грид.
            this.showLoader();
            this._dataSource.save(copy).subscribe(result => {
                // Копия добавляется сразу после оригинала
                this._agGridApi.deselectAll();
                this._agGridApi.updateRowData({ add: [result], addIndex: addIndex });
                this.hideLoader();
            }, error => {
                this.showError(error);
            });
        }
        else {
            // Если у нас клиентская модель данных, то добавляем копию в грид как новую строку
            // Сохранение пойдет на этапе сохранения изменений в таблице в целом.
            // Копия добавляется сразу после оригинала
            this._state.addedRows.push(copy);
            this.notifyStateObservers();
            this._agGridApi.deselectAll();
            this._agGridApi.updateRowData({ add: [copy], addIndex: addIndex });
        }
    }
    /**
     * Обработчик редактирование строки грида.
     * Если грид использует инлайн-модель редактирования, то редактирование пойдет
     * через внутренние механизмы AgGrid и будет активировано через двойной клик, по ячейке строки.
     * Следовательно этот метод будет вызван только при редактировании через модалку.
     *
     * Способ сохранения результатов редактирования зависит оттипа модели данных грида:
     * 1. При клиентской модели данных произойдет апдэйт строки в гриде и добавление ее в массив
     *    обновленных строчек в стэйте.
     *
     * 2. При сервреной модели данных произойдет предварительное сохранение изменений через датасорс.
     *    В стэйт строка добавлена не будет.
     */
    _handleEditAction(action) {
        // Единственность выделения гарантируется панелью инструментов
        const selection = this._state.selectedRows[0];
        // Наличие модалок гарантируется валидацией конфига
        // Если пользователь нажал в модальном окне на отмену - вернется нул.
        this._modalsProvider.showEditForm(selection).subscribe(row => {
            if (row) {
                if (this.options.useServerSideDataModel) {
                    this.showLoader();
                    this._dataSource.save(row).subscribe(result => {
                        this._agGridApi.deselectAll();
                        this._agGridApi.updateRowData({ update: [result] });
                        this.hideLoader();
                    }, error => {
                        this.showError(error);
                    });
                }
                else {
                    this._state.addUpdatedRow(row);
                    this.notifyStateObservers();
                    this._agGridApi.deselectAll();
                    this._agGridApi.updateRowData({ update: [row] });
                }
            }
        });
    }
    /**
     * Обработчик удаления строки грида.
     * Способ удаления строчек определяется моделью данных грида:
     * 1. При клиентской модели данных удаленные строчки помещаются в массив удаленных строк в стэйте для последующего
     *    сохранения изменений через внешнее, относительно грида, сохранение (так как датасорс не задан).
     *
     * 2. При серверной модели данных строчки удаляются напрямую через датасорс и накопление удаленных строк
     *    в стэйте грида не происходит.
     */
    _handleRemoveAction(action) {
        const selection = [...this._state.selectedRows];
        const remove = () => {
            if (this.options.useServerSideDataModel) {
                if (selection.length === 1) {
                    this.showLoader();
                    this._dataSource.delete(selection[0].getRowId()).subscribe(id => {
                        // TODO: Это только ради клиентской эмуляции
                        // TODO: Удалить эту строчку при реализации серверного удаления
                        this._agGridDataSource.addRemovedRows(selection);
                        this.refresh();
                        this.rowsRemove.emit(new DxAppEvent('dx-grid', selection));
                    }, error => {
                        this.showError(error);
                    });
                }
                else {
                    const ids = [];
                    selection.forEach(row => ids.push(row.getRowId()));
                    this._dataSource.deleteAll(ids).subscribe(ids => {
                        // TODO: Это только ради клиентской эмуляции
                        // TODO: Удалить эту строчку при реализации серверного удаления
                        this._agGridDataSource.addRemovedRows(selection);
                        this.refresh();
                        this.rowsRemove.emit(new DxAppEvent('dx-grid', selection));
                    }, error => {
                        this.showError(error);
                    });
                }
            }
            else {
                // Если используется клиентская модель данных, то просто удаляем строки из гида
                // и добавляем их добавляем в массив удаленых строк в стейте чтоб внешний клиент
                // грида мог их как-то удалить например.
                selection.forEach(row => {
                    row.isSelected = false;
                    this._state.removedRows.push(row);
                });
                this._state.clearSelected();
                this.notifyStateObservers();
                this._agGridApi.updateRowData({ remove: selection });
                this.rowsRemove.emit(new DxAppEvent('dx-grid', selection));
            }
        };
        if (this._modalsProvider) {
            let msg = 'Вы действительно хотите удалить ';
            const elements = [];
            selection.forEach(row => elements.push(row.getRowTitle()));
            msg += elements.join(', ') + '?';
            this._modalsProvider.showConfirm(msg).subscribe(confirmed => {
                if (confirmed)
                    remove();
            });
        }
        else {
            remove();
        }
    }
    /** Обработчик экспорта в .xlsx. */
    _handleXlsxExportAction(action) {
        const columns = this.options.columns;
        const filters = AgGridUtils.prepareFilters(columns, this._agGridApi.getFilterModel(), this._gridDicts);
        const sorts = AgGridUtils.prepareSorts(columns, this._agGridApi.getSortModel());
        // Для серверной модели данных эксельник должен формироваться на сервере :)
        // Истинен только путь сей :)
        if (this.options.useServerSideDataModel) {
            this.showLoader();
            this._dataSource.exportXlsx(this.options, filters, sorts).subscribe(xlsx => {
                this.hideLoader();
            }, error => {
                this.showError(error);
            });
        }
        else {
            // Может выполнятся долго
            this.showLoader();
            DxGridUtils.exportXlsx(this.options, this._rows, filters, sorts, this._gridDicts);
            this.hideLoader();
        }
    }
    /** Обработчик экспорта в .pdf. */
    _handlePdfExportAction(action) {
    }
    _handleRowDataLoad(isLoading) {
        if (isLoading) {
            this.showLoader();
        }
        else {
            this.hideLoader();
        }
    }
    _handleRowDataLoadError(error) {
        this.showError(error.message);
    }
    _fetchDicts() {
        const idents = [];
        this.options.columns
            .filter(column => column.dataType.isDictionary)
            .forEach(column => idents.push(column.dataType.dictIdent));
        return this._nciService.fetchDictionaries(idents).pipe(map((dictionaries) => {
            const dictsMap = new Map();
            dictionaries.forEach(dict => dictsMap.set(dict.ident, dict));
            return dictsMap;
        }));
    }
    /**
     * Метод (api) для серверной модели с datasource, который позволяет итерировать по пришедшим с сервера данным.
     * Это оффициальный подход описанный тут: https://www.ag-grid.com/javascript-grid-accessing-data/
     */
    forEachDisplayed(callbackFn) {
        const rowCount = this._agGridApi.getDisplayedRowCount();
        const lastGridIndex = rowCount - 1;
        const currentPage = this._agGridApi.paginationGetCurrentPage();
        const pageSize = this._agGridApi.paginationGetPageSize();
        const startPageIndex = currentPage * pageSize;
        let endPageIndex = (currentPage + 1) * pageSize - 1;
        if (endPageIndex > lastGridIndex) {
            endPageIndex = lastGridIndex;
        }
        const rowNodes = [];
        for (let i = startPageIndex; i <= endPageIndex; i++) {
            const rowNode = this._agGridApi.getDisplayedRowAtIndex(i);
            if (!rowNode.data) {
                // WARNING: при частом обращении за данными из datasource, данные в rowNode пропадают!
                // это косяк имплементации
                return;
            }
            callbackFn(rowNode.data);
            rowNodes.push(rowNode);
        }
        this._agGridApi.redrawRows({ rowNodes });
    }
}
tslib_1.__decorate([
    debounce(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], DxGridComponent.prototype, "onWindowResize", null);
